import { routes } from "@/helpers";
import { useGetConditionalAccessGroupQuery } from "@/services";
import { Button, Spin } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

interface IProps {
  id: string;
}

export const ConditionalAccessName = ({ id }: IProps) => {
  const {
    data: { name } = {},
    isFetching,
    isError,
  } = useGetConditionalAccessGroupQuery(id, { skip: !id });

  if (isFetching) return <Spin />;

  if (isError) return <FormattedMessage id="general.unknown" />;

  return (
    <Button data-test-id={`conditional-access-link-${id}`} type="link">
      <Link to={routes.admin.conditionalAccess.get(id)}>{name}</Link>
    </Button>
  );
};
